import {
  ChallengeCustomField,
  ChallengeViralLoopAuthenticationMethodCustomField,
} from '@types';
import {
  ChallengeFormType,
  ConverterCustomFieldData2Form,
  ConverterForm2CustomFieldData,
} from '../../NewChallengeForm.types';

export const convertForm2Data: ConverterForm2CustomFieldData<
  Pick<ChallengeFormType, 'viralLoopAuthenticationMethod'>,
  Extract<ChallengeCustomField, { name: 'viralLoopAuthenticationMethod' }>
> = ({ viralLoopAuthenticationMethod }) => {
  if (!viralLoopAuthenticationMethod) return [];
  return [
    {
      name: 'viralLoopAuthenticationMethod',
      values: viralLoopAuthenticationMethod,
    },
  ];
};

export const convertData2Form: ConverterCustomFieldData2Form<
  Pick<ChallengeFormType, 'viralLoopAuthenticationMethod'>
> = (customFields) => {
  const viralLoopAuthenticationMethod = customFields.find(
    ({ name }) => name === 'viralLoopAuthenticationMethod',
  );

  if (!viralLoopAuthenticationMethod) return {} as EmptyObj;

  const { values } =
    viralLoopAuthenticationMethod as ChallengeViralLoopAuthenticationMethodCustomField;

  return { viralLoopAuthenticationMethod: values };
};
